export const BASE_SCORE = 'HOTELS_MODULE.DETAIL_DESCRIPTION.SCORE.';

export enum ScoreType {
  Fantastic = 'Fantastic',
  Fabulous = 'Fabulous',
  Good = 'Good',
  Nice = 'Nice'
}

export const SCORE = {
  [ScoreType.Fantastic]: 'FANTASTIC',
  [ScoreType.Fabulous]: 'FABULOUS',
  [ScoreType.Good]:  'GOOD',
  [ScoreType.Nice]: 'NICE'
};
